
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import FAQSchema from "@/components/seo/FAQSchema";

const FAQSection = () => {
  const faqData = [
    {
      question: "What makes Spharaka XDR™ different from other security solutions?",
      answer: "Spharaka XDR™ stands apart through its innovative Agentic AI technology that enables true autonomous security operations. Unlike traditional solutions that require constant human oversight, our platform can independently detect, investigate, and respond to threats 24/7, dramatically reducing your security team's workload while improving detection accuracy."
    },
    {
      question: "How does Agentic AI improve security operations?",
      answer: "Our Agentic AI performs autonomous investigation with AuraAI reasoning, conducts thorough investigations by correlating data across your environment, prioritizes threats based on risk, enriches alerts with contextual information, and continuously learns from new threats and analyst feedback to improve over time. This results in fewer false positives, faster detection, and more effective response."
    },
    {
      question: "How quickly can Spharaka XDR™ be deployed?",
      answer: "Spharaka XDR™ can be deployed in hours, not months, with minimal configuration required. Our cloud-native architecture and intelligent onboarding process mean you can start seeing value from day one, unlike traditional security tools that require extensive setup and tuning."
    },
    {
      question: "Does Spharaka XDR™ replace our existing security tools?",
      answer: "Spharaka XDR™ can either replace your existing security stack or integrate with it to enhance its capabilities. Our platform is designed to consolidate multiple security functions into a single unified solution, but can also work alongside your current investments to maximize their value while providing additional protection."
    },
    {
      question: "How does Spharaka ensure the AI makes the right decisions?",
      answer: "Spharaka's Agentic AI is built on a foundation of security expertise and operates within carefully defined parameters. The AI provides clear explanations for its decisions, and all automated actions can be reviewed by your team. You maintain complete control over which actions the AI can take autonomously, ensuring the right balance of intelligence and human oversight."
    },
    {
      question: "How do we ensure security, especially data security when using agentic AI?",
      answer: "Spharaka implements multiple layers of security to protect your data when using agentic AI. All data processing occurs within encrypted environments with zero trust architecture. Our AI models are trained on anonymized datasets and operate with strict data governance controls. We maintain SOC 2 Type II compliance, employ end to end encryption for all data in transit and at rest, and provide granular access controls. Additionally, sensitive data never leaves your environment without explicit permission, and all AI decisions are logged and auditable for complete transparency."
    }
  ];

  return (
    <section className="py-16 bg-white" id="faq">
      <FAQSchema faqs={faqData} title="Spharaka XDR™ Frequently Asked Questions" />
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Frequently Asked <span className="text-[#8932c8]">Questions</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Everything you need to know about Spharaka XDR™
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem key={`item-${index + 1}`} value={`item-${index + 1}`} className="border rounded-lg border-slate-200 px-6">
                <AccordionTrigger className="text-xl font-semibold py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
